module.exports = __webpack_public_path__ + "static/img/weather12.55a1b4fa.png";